import { HttpStatusCode } from "axios";
import { alertConstants } from "../../helper/sweet-alert";
import MediaContentService from "../../apiServices/masters/mediaContentService";
import { setMediaContent, setMediaContents } from "../../store/slices/master/mediaContentSlice";

export function getMediaContent(id: number) {
  return async function (dispatch: any, getState: any) {
    let response = await MediaContentService.getMediaContent(id);
    if (response?.success === true) {
      dispatch(setMediaContent(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getMediaContents(configUserRole?: number) {
  return async function (dispatch: any, getState: any) {
    let response = await MediaContentService.getMediaContents(configUserRole);
    if (response?.success === true) {
      dispatch(setMediaContents(response.data));
    } else {
      console.log("error");
    }
  };
}

export function createMediaContent(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await MediaContentService.createMediaContent(data);
    const name = data.get("title")
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict, name);
      }
      else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateMediaContent(data: any, id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await MediaContentService.updateMediaContent(data, id);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateMediaContentPriority(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await MediaContentService.updateMediaContentPriority(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      callback(alertConstants.error);
    }
  };
}

export function deleteMediaContent(id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await MediaContentService.deleteMediaContent(id);
    if (response === true) {
      callback(alertConstants.inactiveSuccess);
    } else {
      callback(alertConstants.inactiveFailure);
    }
  };
}
